import { Box, TableCell, TableRow } from "@mui/material";

const ShimmerTableRow = ({ columnCount = 7 }) => {
  return (
    <TableRow data-testid="shimmer-row">
      <TableCell sx={{
        width: '60px',
      }}>
        <Box className="shimmer-content" sx={{ width: 24, height: 24, borderRadius: '4px' }} />
      </TableCell>
      {Array.from({ length: columnCount - 2 }).map((_, index) => (
        <TableCell className="custom-data-table-cell"
          key={index}

        >
          <Box className="shimmer-content" sx={{ width: '100%' }} />
        </TableCell>
      ))}
      <TableCell sx={{
        width: '60px',
      }}>
      </TableCell>
    </TableRow>
  );
};

export default ShimmerTableRow;
